import React from "react";
import "./FeatureCard.css";

const FeatureCard = ({ title, description, badge, icon }) => {
  return (
    <div className="katch-card">
      {badge && <span className="katch-badge">{badge}</span>}

      <span className="katch-card-header">
        {icon && <div className="katch-card-icon">{icon}</div>}
        <h3>{title}</h3>
      </span>

      <p>{description}</p>
    </div>
  );
};

export default FeatureCard;
